import { render } from "./ExpertChatMessage.vue?vue&type=template&id=d5bec026&scoped=true"
import script from "./ExpertChatMessage.vue?vue&type=script&lang=js"
export * from "./ExpertChatMessage.vue?vue&type=script&lang=js"

import "./ExpertChatMessage.vue?vue&type=style&index=0&id=d5bec026&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5bec026"]])

export default __exports__